app.controller(
    'SetController', ['$scope', '$rootScope', '$state', '$stateParams', '$location', '$translate', '$window', 'GroupService', 'SideBarService', 'HelperService', 'ShareUrlService', 'ExplorerService', SetController]
);

function SetController($scope, $rootScope, $state, $stateParams, $location, $translate, $window, GroupService, SideBarService, HelperService, ShareUrlService, ExplorerService) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.IsCreatingNewDescriptionForGroup = false;

    vm.Group = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            DescriptionNewPositionText: '1'
        };    
    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.classifications = [
    {
        name: 'Art moderne',
        checked: true
    },
    {
        name: 'Haute époque',
        checked: true
    }
    ];

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.id) {
        vm.ParamGroupId = $stateParams.id;
    }
    else {
        vm.ParamGroupId = 1;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }

    initController();

    function initController() {
        loadGroup(vm.ParamGroupId, vm.ParamQcId, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    }

    function loadGroup(groupId, qc, lang, lang2, index, sortKey, reverse) {
        GroupService.GetGroup(groupId, qc, lang, lang2, index, sortKey, reverse)
            .then(function (group) {
                vm.Group = group;
                if (vm.Group.DescriptionList.length > 0) {
                    if ($stateParams.descpos) {
                        if ($stateParams.descpos > vm.Group.DescriptionList.length) {
                            $stateParams.descpos = vm.Group.DescriptionList.length;
                        }
                        vm.ActiveDescriptionId = $stateParams.descpos - 1;
                    }
                    else {
                        vm.ActiveDescriptionId = 0;
                    }
                    vm.ActiveDescription = vm.Group.DescriptionList[vm.ActiveDescriptionId];
                    vm.GetDescriptionVm();
                }

                $rootScope.Clients = group.ClientList;
                $rootScope.Comments = group.CommentList;
                $rootScope.SideBar = group.SideBar;

                $rootScope.CurrentObjectId = groupId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Group;
                $rootScope.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;
                $rootScope.SideBar.MesNotes = vm.Group.Group.MyNotes;                

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();
                vm.GetAssociatedFilesOnSideBar();

                vm.StatusList4WorkflowDescriptionObj = angular.copy($rootScope.StatusList4WorkflowDescriptionSt);

                //$scope.ChangeZoneById(vm.ParamZoneId);

                //Parent QC and length limit for description                       
                $rootScope.CheckDescriptionLengthLimitForObject(group.CurrentParentQcId);

                //Classify QC N1 and N2                
                $rootScope.SideBar.QcN1 = GetItemByFieldNameV2($rootScope.SideBar.QualificationList, 'qcParentId', 0);                
                $rootScope.SideBar.QcN2 = $rootScope.getChildQcOfSelectedParent($rootScope.SideBar.QualificationList, $rootScope.SideBar.QcN1);
            });
    }

    vm.UpdateGroup = function () {
        GroupService.UpdateGroup(vm.Group.GroupTrans)
            .then(
                function success(data) { },
                function error(data) { });
    }

    vm.UpdateDescriptionVm = function () {
        if (!vm.IsCreatingNewDescriptionForGroup) {
            HelperService.UpdateDescriptionVm(vm.ActiveDescriptionVm, $rootScope.EnumLinkType.Group)
                .then(
                    function success(data) {
                        //recharge la page si la position du desc est modifié
                        if (vm.ActiveDescriptionVm.DescriptionCurrentPositionText != vm.ActiveDescriptionVm.DescriptionNewPositionText) {
                            window.location.reload();
                        }
                    },
                    function error(data) { });
        }
        else {
            vm.CreateNewDescriptifForGroup();
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Group", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      if ($rootScope.returnNewHistory!==undefined)
                        $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.Group.SideBar.CommentEdit, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                });
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {
        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group)
            .then(
                function success(data) { },
                function error(data) { });
    }; 

    vm.PrepareCreateNewDescriptifForGroup = function () {
        //add new desc local
        vm.IsCreatingNewDescriptionForGroup = true;
        var newDescLocal = {};
        newDescLocal.DescriptionId = 0;

        vm.ActiveDescriptionVm.Description = {};
        vm.ActiveDescriptionVm.Description.DescriptionId = 0;
        vm.ActiveDescriptionVm.Description.DescriptionTitle = '';
        vm.ActiveDescriptionVm.Description.Stick = '';
        vm.ActiveDescriptionVm.Description.Resume = '';
        vm.ActiveDescriptionVm.Description.Description = '';
        vm.ActiveDescriptionVm.DescriptionStatus = '';
        vm.ActiveDescriptionVm.Clients = [];
        vm.ActiveDescriptionVm.QualificationList = [];

        var lastIndex = vm.Group.DescriptionList.push(newDescLocal) - 1;
        vm.ActiveDescriptionId = lastIndex;
    }

    vm.CreateNewDescriptifForGroup = function () {
        //prepare data supplement
        var descForCreation = {};

        descForCreation.ObjectId = vm.Group.GroupTrans.GroupId;
        descForCreation.CurrentLang = $scope.CurrentLang;
        descForCreation.LinkTypeId = $rootScope.EnumLinkType.Group;
        descForCreation.DescriptionTranslation = vm.ActiveDescriptionVm.Description;
        descForCreation.DescriptionStatus = vm.ActiveDescriptionVm.DescriptionStatus;

        GroupService.CreateNewDescriptionForGroup(descForCreation)
        .then(
                function success(data) {
                    vm.IsCreatingNewDescriptionForGroup = false;

                    vm.Group.DescriptionList[vm.ActiveDescriptionId] = $rootScope.returnNewDesc;                
                    $state.go('app.consultation.set', { id: vm.Group.GroupTrans.GroupId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.Group.DescriptionList.length });

                },
                function error(data) { }
        );
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder +'/#!/consultation/set?id=' + vm.Group.GroupTrans.GroupId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.Group.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, vm.ParamQcId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }    

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
                });
                }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() { 
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    vm.GetAssociatedFilesOnSideBar = function () {
        HelperService.GetAssociatedFilesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedFiles = data;
            });
    }

    $rootScope.DownloadAssociatedFile = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        //path = 'test';
        //if ($stateParams.path !== undefined)
        //    path = $stateParams.path + "/" + name;
        ExplorerService.DownloadAssociatedFile(path, "application/pdf")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );

    };

    vm.PreviousDesc = function () {
        if (vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
            $state.transitionTo('app.consultation.set', { id: vm.Group.GroupTrans.GroupId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
        }
    }

    vm.NextDesc = function () {
        if (vm.ActiveDescriptionId < vm.Group.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            $state.transitionTo('app.consultation.set', { id: vm.Group.GroupTrans.GroupId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
            
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Group);
    };

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionPosition(vm.Group.GroupTrans.GroupId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Group);
        }
    }

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareFicheComplete();
    }

    $rootScope.shareFicheComplete = function () {
        ShareUrlService.GenerateSharedUrl($stateParams.id, $rootScope.EnumLinkType.Group, $rootScope.LangForWork)
            .then(function (data) {
                $rootScope.ShareUrlObj = data.data;
            },
            function (data) {
            }
        );
    }
}